/**
 * Admin deductions endpoints, on the generated OpenAPI client.
 */

import { unwrap } from '@billda/api';
import type {
  CancelAdminDeductionRequest,
  CreateAdminDeductionRequest,
  EditAdminDeductionRequest,
} from '@billda/api';
import { api } from '../../../shared/api/billdaApi';

/**
 * Creates an admin deduction (immediately Approved, pot auto-created if needed).
 * `deductionDate` decides which pot period it lands in — today when omitted.
 */
export async function createAdminDeduction(
  request: CreateAdminDeductionRequest,
  signal?: AbortSignal
) {
  return unwrap(
    await api.legacy.POST('/api/v1/deductions', { body: request, signal })
  );
}

export async function editAdminDeduction(
  deductionId: string,
  request: EditAdminDeductionRequest,
  signal?: AbortSignal
) {
  return unwrap(
    await api.legacy.PUT('/api/v1/deductions/{deductionId}', {
      params: { path: { deductionId } },
      body: request,
      signal,
    })
  );
}

export async function cancelAdminDeduction(
  deductionId: string,
  request: CancelAdminDeductionRequest,
  signal?: AbortSignal
) {
  return unwrap(
    await api.legacy.PUT('/api/v1/deductions/{deductionId}/cancel', {
      params: { path: { deductionId } },
      body: request,
      signal,
    })
  );
}

/**
 * Works out which pot period a deduction date lands in, and whether that pot
 * still accepts deductions. Creates nothing.
 */
export async function getDeductionTargetPeriod(
  query: { date: string; gangId?: string; targetWorkerId?: string },
  signal?: AbortSignal
) {
  return unwrap(
    await api.legacy.GET('/api/v1/deductions/target-period', {
      params: { query },
      signal,
    })
  );
}

/**
 * Fetches all deductions for a given pot period (admin view).
 */
export async function getDeductions(potPeriodId: string, signal?: AbortSignal) {
  return unwrap(
    await api.legacy.GET('/api/v1/deductions', {
      // Capitalised because the handler binds the query into GetDeductionsRequest
      params: { query: { PotPeriodId: potPeriodId } },
      signal,
    })
  );
}
